import '@/src/styles/index.scss';
import type { AppProps } from 'next/app';
import { Caveat, DM_Sans } from 'next/font/google';
import Script from 'next/script';

import { HeaderContextProvider } from '../components/providers/headerContextProvider/HeaderContextProvider';
import { ModalProvider } from '../components/providers/modalContext/ModalContext';

const dmSans = DM_Sans({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-dm-sans',
    display: 'swap',
});

const caveat = Caveat({
    subsets: ['latin'],
    weight: ['400', '700'],
    variable: '--font-caveat',
    display: 'swap',
});

export default function App({ Component, pageProps }: AppProps) {
    return (
        <>
            <style jsx global>
                {`
                    html {
                        font-family: ${dmSans.style.fontFamily}, sans-serif;
                    }
                    .caveat {
                        font-family: ${caveat.style.fontFamily}, sans-serif;
                    }
                `}
            </style>
            <ModalProvider>
                <HeaderContextProvider>
                    <Component {...pageProps} />
                </HeaderContextProvider>
            </ModalProvider>
            <Script
                strategy="afterInteractive"
                src="https://www.googletagmanager.com/gtag/js?id=G-FQ2DK811EC"></Script>
            <Script id="gtag-init" strategy="afterInteractive">
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'G-FQ2DK811EC');
                `}
            </Script>
        </>
    );
}
